import { createActionGroup, emptyProps } from '@ngrx/store';

export const LifecycleActions = createActionGroup({
  source: 'Lifecycle',
  events: {
    paused: emptyProps(),
    resumed: emptyProps()
  }
});
